import { render } from "./UploadBox.vue?vue&type=template&id=65fb6705&scoped=true"
import script from "./UploadBox.vue?vue&type=script&lang=js"
export * from "./UploadBox.vue?vue&type=script&lang=js"

import "./UploadBox.vue?vue&type=style&index=0&id=65fb6705&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fb6705"]])

export default __exports__